import React from 'react';
import PropTypes from 'prop-types'

import { Persona } from 'office-ui-fabric-react/lib/Persona'

import Assessment from '../containers/Assessment'
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button'


    
const groupBy = (acc,assessment) => { 
  console.log(assessment.id)
  console.log(assessment.employee)
  const key = assessment.employee.company.id
  if (!acc[key]) acc[key] = []
  acc[key].push(assessment)
  return acc
}


/**
 * Note when employee is null, the ID in firestore might have a space
 * @param {*} employee 
 */
const employeeToPersona = (assessmentId,employee) => {
  // assessmentId
  const displayName = true // showId 
    ?  employee.firstName + ' ' + employee.lastName //+ ' ' + assessmentId.substring(0,3)
    : employee.firstName + ' ' + employee.lastName
  const initials = employee.firstName ? employee.firstName.substring(1,1) + employee.lastName.substring(1,1) : 'A' 
  return {
    id: employee.id,
    primaryText: displayName,
    secondaryText: employee.position,
    imageInitials: initials //employee.initials
  }
}

const assessmentPersona = (assessment,handlePersonaClick,invalidateAssessment,invalidateActivity) => {
  return <div key={assessment.id}><Persona
      { ...employeeToPersona(assessment.id,assessment.employee)  }
      onClick={e => 
        handlePersonaClick(assessment,[
          { text: 'Assessments', 'key': 'Assessments', onClick: invalidateAssessment },
          { text: assessment.employee.firstName + ' ' + assessment.employee.lastName, 'key': 'employeeName', 
            onClick: invalidateActivity,  isCurrentItem: true } 
          ] )
        
      }
    /><br/></div>
}

const Assessments = ({generateAssessments,
  selectedAssessment, assessments,selectAssessment, invalidateAssessment,
  handlePersonaClick,posts, auth, profile,
  invalidateActivity, isFetching, formatEmployee,employeeById,
  activitiesByEmployeeId, asyncMessage, adminState }) => (  
    <div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">

  <div className="ms-Grid">
    {/* UNUSEDJSON.stringify(activitiesByEmployeeId) */}
    { selectedAssessment
      ? <Assessment assessment={selectedAssessment}
          onClick={invalidateAssessment} asyncMessage={asyncMessage} />
        : isFetching 
            ? <span>Loading</span> 
            : profile && profile.permissions && profile.permissions.indexOf('Assessments') >= 0
                && assessments //> 0 && permissions.length > 0)
          ? <div className="ms-Grid-row"> {Object.entries(assessments.reduce( groupBy, {} ) ).map( ([key,assessments]) => 
              <div key={key} className="ms-Grid-col ms-lg3"><h3>{key}</h3>
              {assessments.map( assessment => 
                assessmentPersona(assessment,handlePersonaClick,invalidateAssessment,invalidateAssessment)    )}
              </div>
          )}</div>
          : ''
    }

    </div>
    {/*<div className="ms-Grid-row"><div className="ms-Grid-col ms-lg12">
      <PrimaryButton text='Create Assessments' onClick={generateAssessments('8b5uVXyVLzXm89QKOKYZWt3vn9Y2',
            'Jun 18 FLP Ops','flpops20190718','flp_ops_2019_act',10)} />
  </div></div>*/}

  </div></div>
)




Assessments.propTypes = {
  assessments: PropTypes.array,
  posts: PropTypes.array,
  selectAssessment: PropTypes.func,
  invalidateAssessment: PropTypes.func,
  store: PropTypes.shape({
    firestore: PropTypes.object
  })
}

export default Assessments




// WEBPACK FOOTER //
// ./src/assessments/components/Assessments.js